import {axiosConfig} from '../api/axios-config.js'

// AI 知識庫
export const aiKnowledge = {
  // 取得清單
  get: (params, token) => axiosConfig.get('/api/ai/knowledge', {
    params,
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得單筆
  getById: (id, token) => axiosConfig.get(`/api/ai/knowledge/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 創建
  create: (data, token) => axiosConfig.post('/api/ai/knowledge', data, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 更新
  update: (id, data, token) => axiosConfig.put(`/api/ai/knowledge/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 刪除
  delete: (id, token) => axiosConfig.delete(`/api/ai/knowledge/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 標記有用
  helpful: (id, token) => axiosConfig.post(`/api/ai/knowledge/${id}/helpful`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 回報問題
  report: (id, token) => axiosConfig.post(`/api/ai/knowledge/${id}/report`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得類型
  getTypes: (token) => axiosConfig.get('/api/ai/knowledge/types', {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // 取得標籤
  getTags: (token) => axiosConfig.get('/api/ai/knowledge/tags', {
    headers: { Authorization: `Bearer ${token}` }
  }),

  // AI 類型管理
  types: {
    get: (token) => axiosConfig.get('/api/ai/types', {
      headers: { Authorization: `Bearer ${token}` }
    }),
    create: (data, token) => axiosConfig.post('/api/ai/types', data, {
      headers: { Authorization: `Bearer ${token}` }
    }),
    update: (id, data, token) => axiosConfig.put(`/api/ai/types/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    }),
    delete: (id, token) => axiosConfig.delete(`/api/ai/types/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  },

  // AI 標籤管理
  tags: {
    get: (params, token) => axiosConfig.get('/api/ai/tags', {
      params,
      headers: { Authorization: `Bearer ${token}` }
    }),
    suggest: (query, token) => axiosConfig.get('/api/ai/tags/suggest', {
      params: { q: query },
      headers: { Authorization: `Bearer ${token}` }
    }),
    getCategories: (token) => axiosConfig.get('/api/ai/tags/categories', {
      headers: { Authorization: `Bearer ${token}` }
    }),
    create: (data, token) => axiosConfig.post('/api/ai/tags', data, {
      headers: { Authorization: `Bearer ${token}` }
    }),
    update: (id, data, token) => axiosConfig.put(`/api/ai/tags/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` }
    }),
    delete: (id, token) => axiosConfig.delete(`/api/ai/tags/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
  }
}